module.exports = __webpack_public_path__ + "static/7-230f47a3fbc1e6f6728e67297346c668.png";